import {MutationTree} from 'vuex';
import {WidgetState} from '@/modules/widget/store/index'
import Widget from '@/modules/widget/model/Widget'
import _ from 'lodash'

export enum MutationTypes {
    AddWidget = 'ADD_WIDGET',
    SetWidgets = 'SET_WIDGETS',
    UpdateWidget = 'UPDATE_WIDGET',
    UpdateWidgetState = 'UPDATE_WIDGET_STATE',
    ToggleWidgetCatalog = 'TOGGLE_WIDGET_CATALOG',
}

export interface UpdateWidgetDescriptor {
    id: string
    x: number
    y: number
    h: number
    w: number
}

const mutations: MutationTree<WidgetState> = {
    /**
     * Añade un nuevo widget a la lista de widgets existentes
     *
     * @param state
     * @param widget
     */
    [MutationTypes.AddWidget]: (state, widget: Widget) => state.layout.push(widget),

    /**
     * Remplaza la lista de widgets actual por la lista argumentada
     *
     * @param state
     * @param widgets
     */
    [MutationTypes.SetWidgets]: (state, widgets: Widget[]) => state.layout = widgets,

    /**
     * Actualiza un widget existente en el layout actual
     *
     * @param state
     * @param descriptor
     */
    [MutationTypes.UpdateWidget]: (state, descriptor: UpdateWidgetDescriptor) => {
        const index = state.layout.findIndex(w => w.tempId === descriptor.id)
        if (index === -1) {
            throw new Error(`El widget con id ${descriptor.id} no existe en el layout actual`)
        }

        const widget = state.layout[index]!
        widget.positionX = descriptor.x
        widget.positionY = descriptor.y
        widget.columnHeight = descriptor.h
        widget.columnWidth = descriptor.w

        state.layout.splice(index, 1, widget)
    },

    /**
     * Actualiza un valor del estado del widget
     *
     * @param state
     * @param payload
     */
    [MutationTypes.UpdateWidgetState]: (state, payload: {widget: number, path: string, value: any}) => {
        const widget = state.layout.find(w => w.id === payload.widget)
        if (!widget) {
            throw new Error(`El widget ${payload.widget} el cual se intenta actualizar no existe`)
        }

        _.set(widget.state, payload.path, payload.value)
    },

    /**
     * Controla la visibilidad del catalogo de widget
     *
     * @param state
     * @param active
     */
    [MutationTypes.ToggleWidgetCatalog]: (state, active: boolean) => {
        state.widgetCatalog = active
    },
}

export default mutations
